module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_must_eng.b112e1a0.svg";